<script setup>
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {computed} from "vue";
//------------------------------------------------------------------------------------
const store = useStore()
const router = useRouter()
const logout = () => {
  store.commit('authModule/logout')
  router.push( {name: 'login'} )
}
const user = computed( () => {return store.getters['authModule/user']})
//const newMessage = computed( () => {return store.getters['menuModule/newMessage']})
</script>

<template>
  <aside class="main-sidebar sidebar-dark-primary elevation-2">
    <div class="sidebar">
      <nav class="mt-4" v-if="user">

        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">

          <li class="nav-item">
            <router-link :to="{name: 'contract'}" class="nav-link">
              <div class="d-flex">
                <v-icon class="nav-icon" icon="mdi:account-circle-outline"></v-icon>
                <p class="pl-2" v-if="+user.type === 1 || +user.type === 2">Мой договор</p>
                <p class="pl-2" v-else-if="+user.type === 3">Моё свидетельство</p>
                <p class="pl-2" v-else-if="+user.type === 0">Мой статус</p>
              </div>
            </router-link>
          </li>

          <li v-if="+user.type === 1 || +user.type === 2" class="nav-item">
            <router-link :to="{name: 'payments'}" class="nav-link">
              <div class="d-flex">
                <v-icon class="nav-icon" icon="mdi:credit-card-outline"></v-icon>
                <p class="pl-2">Мои платежи</p>
              </div>
            </router-link>
          </li>
          <li v-else class="nav-item">
            <a class="nav-link is-disabled">
              <div class="d-flex">
                <v-icon class="nav-icon" icon="mdi:credit-card-outline"></v-icon>
                <p class="pl-2">Мои платежи</p>
              </div>
            </a>
          </li>

          <li v-if="+user.type === 1 || +user.type === 2" class="nav-item">
            <router-link :to="{name: 'payments-schedule'}" class="nav-link">
              <div class="d-flex">
                <v-icon class="nav-icon" icon="mdi:chart-bar"></v-icon>
                <p class="pl-2">График платежей</p>
              </div>
            </router-link>
          </li>
          <li v-else class="nav-item">
            <a class="nav-link is-disabled">
              <div class="d-flex">
                <v-icon class="nav-icon" icon="mdi:chart-bar"></v-icon>
                <p class="pl-2">График платежей</p>
              </div>
            </a>
          </li>

          <li class="nav-item" v-if="+user.type === 1 || +user.type === 2 || +user.type === 3">
            <router-link :to="{name: 'dialogue'}" class="nav-link">
              <div class="d-flex">
                <v-icon class="nav-icon" icon="mdi:message-text-outline"></v-icon>
                <p class="pl-2">Мои сообщения</p>
              </div>
            </router-link>
          </li>
          <li v-else class="nav-item">
            <a class="nav-link is-disabled">
              <div class="d-flex">
                <v-icon class="nav-icon" icon="mdi:credit-card-outline"></v-icon>
                <p class="pl-2">Мои сообщения</p>
              </div>
            </a>
          </li>

          <li class="nav-item" v-if="+user.type === 2">
            <router-link :to="{name: 'appeals'}" class="nav-link">
              <div class="d-flex">
                <v-icon class="nav-icon" icon="mdi:message-alert-outline"></v-icon>
                <p class="pl-2">Обращения<br>по квартире</p>
              </div>
            </router-link>
          </li>

          <li class="nav-item" v-if="+user.type === 3333">
            <router-link :to="{name: 'documents-upload'}" class="nav-link">
              <div class="d-flex">
                <v-icon class="nav-icon" icon="mdi:file-document-plus-outline"></v-icon>
                <p class="pl-2">Мои документы</p>
              </div>
            </router-link>
          </li>

          <li class="nav-item" v-if="+user.type === 3">
            <router-link :to="{name: 'documents'}" class="nav-link">
              <div class="d-flex">
                <v-icon class="nav-icon" icon="mdi:text-box-multiple-outline"></v-icon>
                <p class="pl-2">Нормативные документы</p>
              </div>
            </router-link>
          </li>

          <li class="nav-item" v-if="+user.type === 1 || +user.type === 2">
            <router-link :to="{name: 'applications'}" class="nav-link">
              <div class="d-flex">
                <v-icon class="nav-icon" icon="mdi:cog-outline"></v-icon>
                <p class="pl-2">Услуги и сервисы</p>
              </div>
            </router-link>
          </li>
          <li class="nav-item" v-else>
            <a class="nav-link is-disabled">
              <div class="d-flex">
                <v-icon class="nav-icon" icon="mdi:cog-outline"></v-icon>
                <p class="pl-2">Услуги и сервисы</p>
              </div>
            </a>
          </li>

          <li class="nav-item" v-if="+user.type === 1 || +user.type === 2">
            <router-link :to="{name: 'history'}" class="nav-link">
              <div class="d-flex">
                <v-icon class="nav-icon" icon="mdi:clipboard-text-clock-outline"></v-icon>
                <p class="pl-2">История действий</p>
              </div>
            </router-link>
          </li>
          <li class="nav-item" v-else>
            <a class="nav-link is-disabled">
              <div class="d-flex">
                <v-icon class="nav-icon" icon="mdi:clipboard-text-clock-outline"></v-icon>
                <p class="pl-2">История действий</p>
              </div>
            </a>
          </li>

        </ul>

        <div class="user-panel p-1"></div>

        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          <li class="nav-item mt-3">
            <a href class="nav-link" @click.prevent="logout">
              <div class="d-flex">
                <v-icon class="nav-icon" icon="mdi:exit-to-app"></v-icon>
                <p class="pl-2">Выход</p>
              </div>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </aside>
</template>

<style scoped>
.menu-header{
  margin:20px;
}
.is-disabled{
  cursor: not-allowed;
  opacity: 0.33;
}
</style>